import { TLinkList } from "../../../types/link-types";
import Heading from "../heading/heading";
import Link from "../link/link";
import styles from "./link-list.module.less";

/**
 * Used in 404 page and search suggestions
 */
const LinkList = ({ title, links }: TLinkList) => (
  <div className={styles.wrapper}>
    {title && (
      <Heading visualType={"h5"} semanticType={"h2"}>
        {title}
      </Heading>
    )}
    {links &&
      links.map((link, index) => (
        <Link className={[styles.link, "body-base"].join(" ")} title={link.title} url={link.url} key={index} />
      ))}
  </div>
);

export default LinkList;
